<template>
  <transition name="confirm-fade" appear>
    <div class="confirm" v-show="showFlag" @click.stop>
      <div class="confirm-wrapper">
        <div class="confirm-content">
          <div class='title'> 手机号登录 </div>
          <slot></slot>
          <div class="operate">
            <div @click="confirm" class="operate-btn">{{confirmBtnText}}</div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script type="text/ecmascript-6">
  export default {
    props: {
      text: {
        type: String,
        default: ''
      },
      confirmBtnText: {
        type: String,
        default: '确定'
      },
      cancelBtnText: {
        type: String,
        default: '取消'
      }
    },
    data() {
      return {
        showFlag: false
      }
    },
    methods: {
      show() {
        this.showFlag = true
      },
      hide() {
        this.showFlag = false
      },
      cancel() {
        this.hide()
        this.$emit('cancel')
      },
      confirm() {
        this.$emit('confirm')
      }
    }
  }
</script>

<style scoped lang="stylus">
  .confirm
    position: fixed
    left: 0
    right: 0
    top: 0
    bottom: 0
    z-index: 998
    background-color: rgba(0, 0, 0, 0.3)
    &.confirm-fade-enter-active
      animation: confirm-fadein 0.3s
      .confirm-content
        animation: confirm-zoom 0.3s
    .confirm-wrapper
      position: absolute
      top: 50%
      left: 50%
      transform: translate(-50%, -70%)
      z-index: 999
      .confirm-content
        width: 270px
        border-radius: 10px
        background: #333
        position relative
        .title
          text-align center
          height 40px
          padding-bottom  10px
          padding-top 10px
          line-height 40px
          font-size 18px
          color #fef044
          border-bottom 1px solid rgba(255, 255, 255, 0.3)
        .text
          padding: 19px 15px
          line-height: 22px
          text-align: center
          font-size: 18px
          color: rgba(255, 255, 255, 0.5)
        .operate
          text-align: center
          font-size: 18px
          border-top: 1px solid rgba(255, 255, 255, 0.3)
          padding 10px
          .operate-btn
            width 60%
            margin: 0 auto
            line-height: 40px
            color: #4a4a4a
            background #f9ec66
            border-radius: 20px
            &.left
              border-right: 1px solid rgba(255, 255, 255, 0.3)

        .cancel
          position absolute
          right -12px
          top -12px
          font-size 30px
          color #999999
          background #333333
          border-radius 50%
  @keyframes confirm-fadein
    0%
      opacity: 0
    100%
      opacity: 1

  @keyframes confirm-zoom
    0%
      transform: scale(0)
    50%
      transform: scale(1.1)
    100%
      transform: scale(1)
</style>
